import { defineNuxtRouteMiddleware, navigateTo, useCookie } from "nuxt/app";

/**
 * Middleware to handle authentication for routes
 * Redirects users based on their authentication status
 */
export default defineNuxtRouteMiddleware(async (to) => {
  // Retrieve the authentication token from cookies
  const authToken: string = useCookie("Token").value ?? "";
  const refreshToken: string = useCookie("RefreshToken").value ?? "";

  // Define routes that do not require authentication
  const unAuthorizedRoutes = ["/", "/error"];

  // Check if the current route is one of the unauthorized routes
  const unAuthPath = unAuthorizedRoutes.includes(to.path);

  // If the user is not authenticated and trying to access a protected route, redirect to home
  if (
    authToken === "" &&
    refreshToken === "" &&
    !unAuthPath &&
    to.path !== "/"
  ) {
    return navigateTo("/");
  }

  // If the user is authenticated and trying to access an unauthorized route, redirect to home
  if (authToken !== "" && unAuthPath) {
    return navigateTo("/home");
  }
});
